import angular from 'angular';
import template from './template.html';
import './style.scss';

export class WebAppAdapter {
    url = '';
    wrappedUrl = '';

    /* @ngInject */
    constructor(EnvSettings, $sce, $scope) {
        this.EnvSettings = EnvSettings;
        this.$sce = $sce;
        this.$scope = $scope;
    }

    $onInit() {
        this.$scope.onDataLoaded = this.onDataLoaded;
        this.$scope.onEventDispatched = this.onEventDispatched;
    }

    $onChanges() {
        this.wrappedUrl = this.$sce.trustAsResourceUrl(this.getWrappedUrl(this.url));
    }

    getWrappedUrl(url) {
        return `${this.EnvSettings.WebAppUrl}/${url}`;
    }
}

export const WebAppAdapterConfiguration = {
    template,
    bindings: {
        url: '<',
        onDataLoaded: '&',
        onEventDispatched: '&',
    },
    controller: WebAppAdapter,
    controllerAs: 'webAppAdapterCtrl',
};

export const IframeSetDimensionsOnloadDirective = function ($window) {
    return {
        restrict: 'A',
        link: function ($scope, element) {
            const messageHandler = (event) => {
                if (event.data.type === 'TalenyaWepAppDataLoaded') {
                    element[0].style.height = `${event.data.height}px`;

                    if ($scope.onDataLoaded && typeof $scope.onDataLoaded === 'function') {
                        $scope.onDataLoaded({ eventData: event.data });
                    }
                }

                if (event.data.type === 'TalenyaWepAppHeightChanged') {
                    element[0].style.height = `${event.data.height}px`;
                }

                if ($scope.onEventDispatched && typeof $scope.onEventDispatched === 'function') {
                    $scope.onEventDispatched({ eventData: event.data });
                }
            };

            $window.addEventListener('message', messageHandler);

            $scope.$on('$destroy', function() {
                $window.removeEventListener('message', messageHandler);
            });
        },
    };
};

angular.module('TALENYA-FE')
    .component('webAppAdapter', WebAppAdapterConfiguration)
    .directive('iframeSetDimensionsOnload', IframeSetDimensionsOnloadDirective);
